/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import * as d3 from "d3";

import * as topojson from "topojson";
import "./d3Chart.css";
import { useDispatch, useSelector } from "react-redux";
import { setMapPie, setclearAll } from "../../../../redux/actions/DisplayChart";
import { simpleKFormatterOnly } from "../../../../redux/constants";
const CountryUrl = "https://unpkg.com/world-atlas@2.0.2/countries-50m.json";
const IndiaUrl =
  "https://raw.githubusercontent.com/deldersveld/topojson/master/countries/india/india-states.json";
// const fs = require('fs');
const MapGraph = ({ single, compare_key, deepDive }) => {
  const [data, setdata] = useState(null);
  const [pieData, setpieData] = useState(null);
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);

  const [isComponentVisible, setIsComponentVisible] = useState(false);
  let xAttribute = graphDetail?.primary_attribute;

  // const width= window.innerWidth
  // const height = window.innerHeight
  const width =
    graphDetail?.split?.columns?.length === 2
      ? window.innerWidth / 2 - 80
      : graphDetail?.split?.columns?.length === 3
      ? window.innerWidth / 3 - 80
      : window.innerWidth - 80;
  // const width = xAttribute === "Country" ? window.innerWidth :570;
  const height = 650;
  const [tooltipPie, setTooltipPie] = useState(null);
  const Divref = useRef();
  const headRef = useRef(null);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const mapTooltip = compare_key ? `${compare_key}map` : "map1";

  // create map element and center at [lat, long]
  let scale =
    graphDetail?.split?.columns?.length === 2
      ? 800
      : graphDetail?.split?.columns?.length === 3
      ? 580
      : 1000;
  let mapLegendWidth =
    graphDetail?.split?.columns?.length === 2
      ? "2rem"
      : graphDetail?.split?.columns?.length === 3
      ? "1.5rem"
      : "3rem";
  let mapLegendHeight =
    graphDetail?.split?.columns?.length === 2
      ? "50rem"
      : graphDetail?.split?.columns?.length === 3
      ? "30rem"
      : "60rem";
  let mapLegendMarginTop =
    graphDetail?.split?.columns?.length === 2
      ? "5rem"
      : graphDetail?.split?.columns?.length === 3
      ? "15rem"
      : "3rem";

  var projection =
    xAttribute === "Country"
      ? d3
          .geoMercator()
          .scale(180)
          .center([0, 20])
          .translate([width / 2, height / 2])
      : d3
          .geoMercator()
          .center([81, 22])
          .scale(scale)
          .translate([width / 2, height / 2]);
  var path = d3.geoPath().projection(projection);

  //to set map data in data state
  useEffect(() => {
    d3.json(xAttribute === "Country" ? CountryUrl : IndiaUrl).then(
      (topojsonData) => {
        let countries;
        var states;
        //for state data
        if (xAttribute !== "Country")
          states = topojson.feature(
            topojsonData,
            topojsonData.objects.IND_adm1
          );
        //for country data
        if (xAttribute === "Country")
          countries = topojson.feature(
            topojsonData,
            topojsonData.objects.countries
          );

        xAttribute === "Country" ? setdata(countries) : setdata(states);
      }
    );
  }, []);

  //calling drawmap function when data is set
  useEffect(() => {
    data && drawMap();
  }, [data]);

  //setting pie data
  useEffect(() => {
    let arr = [];
    if (single[0].lat) {
      let a = single[0].lat;
      let b = single[0].lon;
      let c = single[0].pie_sizes;
      let d = single[0].colors;
      let e = single[0].names;
      let f = single[0].pie_names;
      for (let i = 0; i < single[0].lat?.length; i++) {
        let obj = {
          lat: a[i],
          lon: b[i],
          pie: c[i],
          color: d[i],
          names: e[i],
          pieName: f[i],
          size: single[0].size[i],
        };
        arr.push(obj);
      }
      setpieData(arr);
    }
  }, [single]);

  //calling drawPie when pieData is set
  useEffect(() => {
    pieData && data && drawPie();
  }, [pieData, data]);

  // set params of arc to be used inside pie
  var arc = d3.arc().innerRadius(0).outerRadius(50);

  // d3 pie object
  var arcGenerator = d3
    .pie()
    .padAngle(0)
    .value((d) => d);
  //code to divide count equally in 6 parts
  const getColorDomain = (upperLimit, LowerLimit) => {
    let diff = upperLimit - LowerLimit; //difference of upper limit and lower limit;
    let divValue = Math.round(diff / 5); //divide diff value to 5, to divide in remaining 5 parts
    let v4 = diff - divValue;
    let v3 = v4 - divValue;
    let v2 = v3 - divValue;
    let v1 = v2 - divValue;

    return [0, v1, v2, v3, v4, upperLimit];
  };

  var colorScale = d3
    .scaleThreshold()
    // .domain([10, 20, 30, 50, 100, 5000])
    .domain(
      getColorDomain(Math.max(...single[0].size), Math.min(...single[0].size))
    )
    .range(d3.schemeBlues[7]);

  // const colorScale = d3
  //   .scaleThreshold()
  //   .domain([10, 100, 1000, 5000, 10000, 500000]);

  // colorScale
  //   .domain(
  //     colorScale
  //       .domain()
  //       .filter(function (el) {
  //         return el != null;
  //       })
  //       .sort()
  //   )
  //   .range(d3.schemeOrRd[7]);

  var svg = d3.select(Divref.current).append("svg");
  var g1 = svg.append("g");
  // create another svg group for pies
  var g2 = svg.append("g").attr("class", "Mainpies").style("width", width);

  //   const zoom = d3.zoom()
  //     .scaleExtent([1, 8])
  //     .on('zoom', zoomed);

  // svg.call(zoom);
  // function zoomed(d) {
  //   g1.selectAll('path') // To prevent stroke width from scaling
  //     .attr('transform', d.transform);
  //     g2.selectAll('path') // To prevent stroke width from scaling
  //     .attr('transform', d.transform);
  // }
  //pie tooltip

  //on click function is called for deep dive
  const onPieClick = (event) => {
    let obj;
    obj = {
      x: event.name,
      y: event.pieName,
      split: compare_key ? compare_key : null,
    };
    obj && !deepDive && dispatch(setMapPie(obj)); //set bar values
    !deepDive && dispatch(setclearAll("map_pie")); //clear all charts state except "bar"
  };

  // create the map in first svg group
  const drawMap = () => {
    var selectState = g1
      .selectAll("g")
      .data(data?.features)
      .enter()
      .append("g")
      .attr("class", "state");

    selectState
      .append("path")
      .style("fill", function (d) {
        let index = single[0].names.indexOf(d.properties.NAME_1);

        if (index >= 0) {
          let value = single[0].size[index];

          return colorScale(value[0]);
        } else {
          return "#f1eef6";
        }
      })
      .attr("d", path);

    // svg.selectAll("text").data(data?.features).enter().append("text")
    // .attr("class", function(d) { return "label " + d.id; })
    // .attr("transform", function(d) { return "translate(" + path.centroid(d) + ")"; })
    // .attr("dy", ".35em")
    // .text(function(d) { return d.properties.name; });
  };

  // create the pie chart in second svg group
  const drawPie = () => {
    const tooltip = d3.select(`#${mapTooltip}`);

    var points = g2
      .selectAll("g")
      .data(pieData)
      .enter()
      .append("g")
      .attr("transform", (d) => {
        return "translate(" + projection([d.lon, d.lat]) + ")";
      })
      .attr("id", (d, i) => {
        return "chart" + i;
      })
      .append("g")
      .attr("class", "pies");

    // Select each g element we created, and fill it with pie chart:
    var pies = points.selectAll(".pies").data(function (d) {
      return arcGenerator(d.pie).map((m, i) => {
        m.r = 10;
        let obj = { data: m, color: d?.color[i], name: d.names[i] };
        return obj;
      });
    });
    var arcEnter = pies.enter().append("g").attr("class", "arc");

    arcEnter.attr("class", "arc");
    arcEnter
      .append("path")
      .attr("d", function (d) {
        arc.outerRadius(d.data.r);
        return arc(d.data);
      })
      .attr("fill", function (d) {
        return d.color;
      });

    points.on("mouseover", (e, d) => {
      const tName = d?.names;
      //   if(headRef.current.innerText.length === 0)
      //  {
      //    headRef.current.innerText = tName
      //  }

      const headRef1 = headRef?.current?.innerText;

      if (headRef1?.toLowerCase() !== tName?.toLowerCase()) {
        tooltip.select(".tooltip-contentPie-map svg").remove();
      } else {
        createTooltippie();
      }
      setIsComponentVisible(true);

      setTooltipPie(d);
      tooltip.select(".tooltip-heading-map").text(d?.names);

      tooltip
        .style("top", `${e.offsetY - 50}px`)
        .style("left", `${e.offsetX}px`);
      tooltip.style("visibility", "visible");
      d3.select(this).style("stroke", "#222");
    });

    points
      .transition()
      .delay(700)
      .ease(d3.easeExpInOut)
      .duration(1000)
      .style("opacity", 1)
      .attr("transform", (d) => `translate(${d.x}, ${d.y})`);

    points
      .append("text")
      .style("text-anchor", "middle")
      .style("font-size", (d) => {
        return `${d.r / 3}`;
      })
      .style("font-family", "Roboto Slab")
      .style("font-weight", "600")
      .style("fill", "#2D3E5C");
  };

  // function to create a tooltip for the pie chart
  const createTooltippie = () => {
    const tooltip = d3.select(`#${mapTooltip}`);
    let pieSum = d3.sum(tooltipPie.pie); //sum of all the pie arc values
    let arr = [tooltipPie];

    var points = tooltip
      .select(".tooltip-contentPie-map")
      .selectAll("g")
      .data(arr)
      .enter()
      .append("svg")
      .attr("width", "150")
      .attr("height", "150")
      .attr("class", "pies")
      .append("g")
      .attr("transform", `translate(${75}, ${85})`);

    var pies = points.selectAll(".pies").data(function (d) {
      return arcGenerator(d.pie).map((m, i) => {
        m.r = 60;
        let obj = {
          data: m,
          color: d?.color[i],
          name: d.names,
          pieName: d.pieName[i],
        };
        return obj;
      });
    });

    var arcEnter = pies.enter().append("g").attr("class", "arc");
    arcEnter.attr("class", "arc");
    arcEnter
      .append("path")
      .attr("d", function (d) {
        arc.outerRadius(d.data.r);
        return arc(d.data);
      })

      .style("stroke", "#fff")
      .style("stroke-width", "0.1rem")
      .attr("fill", function (d) {
        return d.color;
      })
      .on("click", (e, d) => onPieClick(d));

    arcEnter
      .append("text")
      .on("click", (e, d) => onPieClick(d))
      //  .attr("transform", function (d) {
      //         return "translate(" + arc.centroid(d.data) + ")";
      //   })
      .attr("transform", function (d) {
        let percent = (d.data.value / pieSum) * 100;
        if (percent < 6) {
          var c = arc.centroid(d.data),
            x = c[0],
            y = c[1],
            // pythagorean theorem for hypotenuse
            h = Math.sqrt(x * x + y * y);
          return "translate(" + (x / h) * 40 + "," + (y / h) * 60 + ")";
        } else {
          return "translate(" + arc.centroid(d.data) + ")";
        }
      })
      // .style("text-anchor", "middle")
      .attr("text-anchor", function (d) {
        let percent = (d.data.value / pieSum) * 100;
        if (percent < 6) {
          return (d.data.endAngle + d.data.startAngle) / 2 > Math.PI
            ? "end"
            : "start";
        } else {
          return "middle";
        }
      })
      .style("font-size", "0.8em")
      .style("fill", "black")
      .text((d) => {
        return `${((d.data.value / pieSum) * 100).toFixed(0)}%`;
      });
    tooltip
      .select(".tooltip-content-map")
      .text(`Mention count: ${simpleKFormatterOnly(tooltipPie.size[0])} `);
  };

  useEffect(() => {
    tooltipPie && createTooltippie();
  }, [tooltipPie]);

  // const useComponentVisible = (initialIsVisible) =>{
  //   const [isComponentVisible, setIsComponentVisible] = useState(
  //     initialIsVisible
  //   );
  //   const ref = useRef(null);

  //   const handleHideDropdown = (event) => {

  //     if (event.key === "Escape") {
  //       setIsComponentVisible(false);
  //     }
  //   };

  //   const handleClickOutside = (event) => {
  //     if (ref.current && !ref.current.contains(event.target)) {
  //       setIsComponentVisible(false);
  //     }
  //   };

  //   useEffect(() => {
  //     document.addEventListener("keydown", handleHideDropdown, true);
  //     document.addEventListener("click", handleClickOutside, true);
  //     return () => {
  //       document.removeEventListener("keydown", handleHideDropdown, true);
  //       document.removeEventListener("click", handleClickOutside, true);
  //     };
  //   });

  //   return { ref, isComponentVisible, setIsComponentVisible };
  // }

  // const {
  //   ref,
  //   isComponentVisible,
  //   setIsComponentVisible
  // } = useComponentVisible(false);

  // window.addEventListener("resize", data && drawMap());
  // window.addEventListener("resize", pieData && drawPie());
  return (
    <>
      <div
        id={compare_key ? compare_key : "1"}
        ref={ref}
        style={{ width: width, height: height, margin: "0 auto" }}
      >
        <div style={{ display: "flex" }}>
          <svg
            id={"mapSvg"}
            style={{ width: "100%", height: height }}
            ref={Divref}
          ></svg>

          <div
            style={{
              display: "flex",
              marginTop: `${mapLegendMarginTop}`,
              height: `${mapLegendHeight}`,
            }}
          >
            <div
              style={{
                width: `${mapLegendWidth}`,
                height: "100%",
                transform: "scale(0.8)",
                background:
                  "linear-gradient(0deg, rgb(241, 238, 246) 0%, rgb(136, 190, 220) 35%, rgb(69, 146, 199) 50%, rgb(28, 105, 174) 70%,rgb(8, 48, 107) 100%)",
              }}
            ></div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                transform: "scale(0.8)",

                flexDirection: "column",
              }}
            >
              <div>{single[0].size[0][0]}</div>
              <div>0</div>
            </div>
          </div>
        </div>
        {isComponentVisible ? (
          <div id={mapTooltip} className="newtooltip-map">
            <div className="d-flex justify-content-between">
              <a className="tooltip-heading-map" ref={headRef} />
              <i
                className="fa fa-times attr_close"
                onClick={() => setIsComponentVisible(false)}
              />
            </div>

            <a className="tooltip-contentPie-map" />
            <a className="tooltip-content-map" />
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="tooltip-legend">
        {pieData &&
          pieData[0]?.pieName?.map((e, i) => {
            return (
              <>
                {" "}
                <span
                  className="color-legend"
                  style={{ backgroundColor: `${pieData[0].color[i]}` }}
                ></span>
                <span>{e}</span>
              </>
            );
          })}
      </div>
    </>
  );
};

export default MapGraph;
